<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
            <div class="member-select-pane mult-member-zone" :class="disabled ? 'is-disabled' : ''" @click="showSelectZone">
                <el-scrollbar height="60px">
                    <span v-if="selectDepartInfo.length == 0">选择部门</span> 
                    <span v-else>
                        <el-tag 
                            v-for="depart in selectDepartInfo"
                            :key="depart.Id"
                            class="qwe-space__item">
                            {{ depart.Name }}
                        </el-tag>
                    </span>
                </el-scrollbar>
            </div>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
        <el-dialog 
            :fullscreen="fullScreen"
            class="selectDepart"
            append-to-body
            lock-scroll
            v-model="showState" 
            title="选择部门"> 
            <template #default>
                <div class="member-select-pane mult-member-zone">
                    <el-scrollbar height="60px">
                        <el-tag 
                            v-for="depart in paneDepartInfos"
                            :key="depart.Id"
                            class="qwe-space__item"
                            closable
                            @close="deleteDepart(depart)">
                            {{ depart.Name }}
                        </el-tag>
                    </el-scrollbar>
                </div>
                <el-scrollbar height="270px">
                    <tree :options="options" 
                          v-model="treeValue"
                          :singleSelect="false">
                    </tree>
                </el-scrollbar>
                <div class="depart-select-footer">
                    <el-button @click="showState = false">取消</el-button>
                    <el-button type="primary" @click="sumbit">确认</el-button>
                </div>
            </template>
        </el-dialog>
    </el-col>
</template>

<style>
    .qwe-space__item{
        margin-right:5px;
        margin-bottom:5px;
    }

    .selectDepart .el-dialog__body{
        padding-top:15px;
        border-top: 1px rgb(164, 168, 176) solid;
    }
    .mult-member-zone{
        height:60px;
        line-height: 32px;
    }
    @media screen and (min-width: 768px){
        .depart-select-footer{
            text-align: right;
        }
    }
    @media only screen and (max-width: 768px) {
        .depart-select-footer{
            margin-left: -21px;
            position: fixed;
            bottom: 0;
            width: 100%;
        }

        .depart-select-footer>button{
            width: 50%;
            margin-left: 0 !important;
            border-radius: 0px;
        }
    }
</style>
    
<script>
    import baseDepartField from './BaseDepartField'
    import Tree from '../../Tree/Tree.vue'

    export default {
        name:"DepartField",
        mixins:[baseDepartField],
        components:{
            'tree':Tree
        }
    }
</script>